<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="itemList"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ itemList.indexOf(props.item) + 1 }}</td>
        <td class="text-xs-center">{{ props.item.province_name_en }}</td>
        <td class="text-xs-center">{{ props.item.store_name_th }}</td>
        <td class="text-xs-left">{{ props.item.user_tel }}</td>
        <td class="text-xs-left">
          {{ moment(props.item.update_at).format("MMMM Do YYYY, HH:mm:ss") }}
        </td>
        <td class="text-xs-center">
          <v-btn @click="showDetail(props.item)" color="info" slot="activator">
            <v-icon class="mr-1">remove_red_eye</v-icon> View document
          </v-btn>
        </td>
      </template>
      <template slot="no-data"></template>
    </v-data-table>
    <v-dialog v-model="detailDialog">
      <v-card style="position: relative">
        <v-toolbar color="primary">
          <v-toolbar-title
            >เอกสารของร้าน : {{ selectedItem.store_name }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              detailDialog = false;
              reject_msg = '';
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout row wrap style="height: calc(100vh - 200px); overflow: auto">
          <v-flex xs12 sm6 style="padding: 24px">
            <div class="my-card">
              <div class="flex-row">
                <div class="text-title">STORE BANK NAME: &nbsp;</div>
                <div class="text-content">
                  {{
                    itemDetail.store_bank
                      ? itemDetail.store_bank.store_bank_account_name
                      : ""
                  }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-title">STORE BANK NUMBER: &nbsp;</div>
                <div class="text-content">
                  {{
                    itemDetail.store_bank
                      ? itemDetail.store_bank.store_bank_account_number
                      : ""
                  }}
                </div>
              </div>
              <div class="flex-row">
                <div class="text-title">STORE BANK: &nbsp;</div>
                <div class="text-content">
                  {{
                    itemDetail.store_bank
                      ? itemDetail.store_bank.store_bank_bank_name_th +
                        "(" +
                        itemDetail.store_bank.store_bank_bank_code +
                        ")"
                      : ""
                  }}
                </div>
              </div>

              <div class="text-title">STORE BANK IMAGE: &nbsp;</div>
              <a
                v-if="
                  itemDetail.store_bank &&
                  itemDetail.store_bank.store_bank_image
                "
                :href="itemDetail.store_bank.store_bank_image"
                target="_blank"
                style="text-decoration: none; color: white; margin-right: 10px"
                class="img-logo-layout"
              >
                <img
                  :src="itemDetail.store_bank.store_bank_image"
                  class="img-logo"
                />
              </a>
            </div>
          </v-flex>

          <v-flex xs12 sm6 style="padding: 24px">
            <div class="my-card">
              <div class="text-title">STORE BUSSINESS IMAGE: &nbsp;</div>
              <div class="images-scroll">
                <v-layout wrap>
                  <v-flex
                    sm4
                    xs6
                    v-for="(info, index) in itemDetail.store_business"
                    :key="`store_business_image-${index}`"
                  >
                    <div style="display: flex; justify-content: center">
                      <a
                        :href="info.store_business_image"
                        target="_blank"
                        style="
                          text-decoration: none;
                          color: white;
                          margin-right: 10px;
                        "
                        class="img-logo-layout"
                      >
                        <v-img
                          :src="info.store_business_image"
                          class="img-logo"
                        />
                      </a>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <div
          style="position: absolute; width: 100%; bottom: 0px; left: 0"
          class="d-flex"
        >
          <v-btn
            color="red"
            dark
            :disabled="isApproving"
            :loading="isRejecting"
            @click="rejectDialog = true"
            >REJECT</v-btn
          >
          <v-btn
            color="green"
            dark
            :loading="isApproving"
            :disabled="isRejecting"
            @click="approveDocument()"
            >APPROVE</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rejectDialog" max-width="500px">
      <v-card>
        <v-card-title
          ><h2>Do you want to reject this documents ?</h2></v-card-title
        >
        <v-card-text>
          <v-text-field
            v-model="rejectMsg"
            label="Message to store"
          ></v-text-field>
          <div class="text-xs-right">
            <v-btn
              flat
              color="red"
              @click="
                rejectDialog = false;
                rejectMsg = null;
              "
              >cancel</v-btn
            >
            <v-btn flat color="green" @click="rejectDocument()">confirm</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
export default {
  props: [
    "itemDetail",
    "itemList",
    "isLoadingDetail",
    "isApproving",
    "isRejecting",
  ],
  data: () => ({
    rejectDialog: false,
    rejectMsg: null,
    selectedItem: {
      user_name: "",
      store_name: "",
      province: "",
    },
    detailDialog: false,
    search: "",
    pagination: { rowsPerPage: 10 },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "product_code",
      },
      {
        text: "Province",
        align: "center",
        sortable: false,
        value: "img",
      },
      // {
      //   text: "Store service",
      //   align: "center",
      //   sortable: false,
      //   value: "product_name_th",
      // },
      // {
      //   text: "User name",
      //   align: "center",
      //   sortable: false,
      //   value: "product_name_en",
      // },
      {
        text: "Store name",
        align: "center",
        sortable: false,
        value: "product_pos_sale_price",
      },
      {
        text: "OWNER tel.",
        align: "center",
        sortable: false,
        value: "product_pos_base_price",
      },
      {
        text: "Request Date/Time",
        align: "center",
        sortable: false,
        value: "product_approve",
      },
      {
        text: "Actions",
        align: "center",
        sortable: false,
        value: "action",
      },
    ],
  }),
  components: {},
  computed: {
    ...mapGetters(["isEditDocumentApprove"]),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {},
  created() {},
  methods: {
    moment,
    rejectDocument() {
      let _this = this;
      console.log(this.itemDetail);
      this.$emit("reject", {
        store_id: this.itemDetail.store_id,
        province: this.selectedItem.province,
        province_id: this.store_province_id,
        msg: this.rejectMsg,
        done() {
          (_this.rejectDialog = false), (_this.detailDialog = false);
        },
      });
    },
    approveDocument() {
      let _this = this;
      this.$emit("approve", {
        store_id: this.itemDetail.store_id,
        province: this.selectedItem.province,
        done() {
          _this.detailDialog = false;
        },
      });
    },
    async showDetail(item) {
      // this.selectedItem.user_name = "";
      this.selectedItem.store_name = item.store_name_th;
      this.selectedItem.province = item.province;
      let configPath = {
        province: item.province,
        store_id: item.store_id,
      };
      this.detailDialog = true;
      this.$emit("fetchDetail", configPath);
    },
  },
};
</script>
<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.images-scroll {
  display: flex;
  max-height: 300px;
  width: auto;
  overflow-y: scroll;
}
.img-logo {
  width: 100%;
}

.img-logo-layout {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  height: 120px;
  width: 120px;
  min-width: 120px;
  position: relative;
  text-align: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
  background: white;
  -webkit-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}
.approve-btn {
  font-size: 13px;
  background-color: green;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.my-card {
  border: 2px solid rgb(242, 242, 242);
  border-radius: 5px;
  padding: 2px 5px;
  margin-bottom: 10px;
}

.text-title {
  font-size: 14px;
  font-weight: 500;
  color: #666;
}
.text-content {
  font-size: 16px;
  font-weight: 500;
}
</style>


